var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "upcoming-table" } },
    [
      _vm.loading
        ? _c("div", { staticClass: "text-center mt-4" }, [
            _c(
              "div",
              {
                staticClass: "spinner-border text-light",
                attrs: { role: "status" },
              },
              [
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v(_vm._s(_vm.$t("common.loading")) + "..."),
                ]),
              ]
            ),
          ])
        : _c(
            "div",
            _vm._l(_vm.activities, function (activity) {
              return _c(
                "div",
                { key: activity.id, staticClass: "activity-section mb-5" },
                _vm._l(activity.warehouses, function (wId) {
                  return _c(
                    "div",
                    { key: wId, staticClass: "warehouse-section mb-4" },
                    [
                      _c("h5", { staticClass: "mb-2" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.getWarehouseName(wId)) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.warehouseActivities[wId] &&
                      _vm.warehouseActivities[wId].length > 0
                        ? _c("div", { staticClass: "table-responsive" }, [
                            _c(
                              "table",
                              { staticClass: "table table-striped" },
                              [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", { attrs: { width: "250" } }, [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(_vm.$t("common.date")) +
                                          "\n                                "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _vm._v(_vm._s(_vm.$t("common.time"))),
                                    ]),
                                    _vm._v(" "),
                                    _vm.activities.length > 1
                                      ? _c("th", [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.$t("common.activity")
                                              ) +
                                              "\n                                "
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("th", [
                                      _vm._v(_vm._s(_vm.$t("common.location"))),
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [_vm._v(" ")]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  _vm._l(
                                    _vm.warehouseActivities[wId],
                                    function (activityItem) {
                                      return _c(
                                        "tr",
                                        { key: activityItem.id },
                                        [
                                          _c("td", [
                                            _c(
                                              "div",
                                              { staticClass: "activity-date" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "date-day" },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.formatDate(
                                                            activityItem.startDate
                                                          )
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c(
                                              "div",
                                              { staticClass: "activity-time" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "time-start" },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.formatTime(
                                                            activityItem.startDate
                                                          )
                                                        ) +
                                                        " - " +
                                                        _vm._s(
                                                          _vm.formatTime(
                                                            activityItem.endDate
                                                          )
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _vm.activities.length > 1
                                            ? _c("td", [
                                                _c("strong", [
                                                  _vm._v(_vm._s(activity.name)),
                                                ]),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(activityItem.locationName)
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              activityItem.canBook
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-sm btn-outline-success",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.bookActivity(
                                                            activityItem
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "actions.reserve"
                                                            )
                                                          ) +
                                                          "\n                                    "
                                                      ),
                                                    ]
                                                  )
                                                : activityItem.reservationStartDate &&
                                                  activityItem.reservationStartDate >
                                                    new Date()
                                                ? _c(
                                                    "span",
                                                    { staticClass: "badge" },
                                                    [
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "upcoming.reservation_not_open"
                                                            )
                                                          ) +
                                                          "\n                                    "
                                                      ),
                                                    ]
                                                  )
                                                : activityItem.reservationEndDate &&
                                                  activityItem.reservationEndDate <
                                                    new Date()
                                                ? _c(
                                                    "span",
                                                    { staticClass: "badge" },
                                                    [
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "upcoming.reservation_closed"
                                                            )
                                                          ) +
                                                          "\n                                    "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]
                            ),
                          ])
                        : _c("div", { staticClass: "text-center mt-3" }, [
                            _c("div", { staticClass: "alert alert-info" }, [
                              _c("i", {
                                staticClass: "fas fa-info-circle me-2",
                              }),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("upcoming.no_upcoming")) +
                                  "\n                    "
                              ),
                            ]),
                          ]),
                    ]
                  )
                }),
                0
              )
            }),
            0
          ),
      _vm._v(" "),
      _vm.selectedItem
        ? _c("ReservationModal", {
            ref: "reservationModal",
            attrs: {
              item: _vm.selectedItem,
              "csrf-token": _vm.csrfToken,
              "has-siblings": false,
            },
            on: {
              close: _vm.handleModalClose,
              reserved: _vm.handleReservationComplete,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAddedToCartModal
        ? _c("add-to-cart-modal", { on: { close: _vm.closeAddedToCartModal } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }